import React, { useContext, useEffect } from 'react';
import { Header } from "./Header";
import styled from "styled-components";
import { AppContext } from '../../contexts/AppContext';
import { TabView } from './TabView';
import {fetchAppConfig, fetchAvailable3plPartners, fetchLocationConfigurations} from '../../services/OrderService';
import { fetchMetaData } from '../../services/CubbyService';
import {getFromStorage, saveToStorage} from '../../services/LocalStorage';
import Modes from '../../contexts/Modes';
import RouteNames from '../../contexts/RouteNames';
import {
  SELF_MANAGED_DELIVERY_PARTNER,
  SELF_MANAGED_DELIVERY_PARTNER_NAME,
  STORAGE_KEY_IS_IN_SELF_MANAGED_MODE,
  STORAGE_KEY_IS_USING_RULE_BASED_CONFIG
} from "../../helpers/Constants";

const Wrapper = styled.div`
background-color: #FFFFFF;
padding: 20px;
height: 100%;
overflow: auto;
width: 100%;
`;

const Container = styled.nav`
  margin: auto;
  height: 100%;
  width: 100%;
  display: flex;
  height: calc(100% - 60px);
`;

export function Dispatcher() {
  const {
    authData,
    loggedIn,
    setLoggedIn,
    kitchen,
    setWaitingTime,
    setMode,
    setBackupAreaId,
    setIsAssignerMode,
    setDefaultDeliveryMode,
    setAvailableDeliveryModes,
    setCurrentRouteName,
    setAvailable3plPartners} = useContext(AppContext);

  useEffect(() => {
    setMode(Modes.DISPATCHER);
    setCurrentRouteName(RouteNames.DISPATCHER);

    if (!loggedIn) {
      // history.replace("/kitchenselect");
      setLoggedIn(true);
      // return;
    }

    let loadedKitchen = kitchen;
    if (!loadedKitchen.id) {
      loadedKitchen = getFromStorage('kitchen');
    }

    if (!loadedKitchen.multiTenant) {
      fetchAppConfig(loadedKitchen.id).then((response) => {
        setWaitingTime(response.pickupWaitingTime);
        setIsAssignerMode(response.assignMode);
      });
    } else {
      setWaitingTime(15);
    }

    fetchMetaData(authData.signInUserSession.idToken.payload.partner_id, loadedKitchen.id).then((response) => {
      setBackupAreaId(response?.backupAreaId?? null)
    });

    fetchLocationConfigurations(authData.signInUserSession.idToken.payload.partner_id, loadedKitchen.id).then((response) => {
      setDefaultDeliveryMode(response.defaultDeliveryMode);
      setAvailableDeliveryModes(response.availableDeliveryModes);
      saveToStorage(STORAGE_KEY_IS_USING_RULE_BASED_CONFIG,
          response.isUsingRuleBasedConfiguration)
      saveToStorage(STORAGE_KEY_IS_IN_SELF_MANAGED_MODE,
          response.isInSelfManagedDeliveryMode)
    }).catch((e) => {
      console.log(e);
    });

    fetchAvailable3plPartners(authData.signInUserSession.idToken.payload.partner_id).then(response => {
      const mappedResponse = new Map();
      response.forEach(deliveryPartner => {
        mappedResponse.set(deliveryPartner.id, deliveryPartner.name);
      })
      mappedResponse.set(SELF_MANAGED_DELIVERY_PARTNER, SELF_MANAGED_DELIVERY_PARTNER_NAME);
      setAvailable3plPartners(mappedResponse)
    }).catch(error => {
      console.log(error)
    })

  }, []);

  return (
    <Wrapper>
      <Header />

      <Container>
        <TabView />
      </Container>
    </Wrapper>
  );
}